import React, { useEffect, useState } from 'react';
import API from 'shared/api';
import { FiCpu } from 'react-icons/fi';
import { COL } from 'shared/darkColors';
import { BarsH, Donut } from 'shared/components/Dashboard/charts';
import {
  S, money, intFmt, pctFmt, Kpi, SectionCard, Cargando, ErrorMsg, buildQuery,
} from './reportesCommon';

export default function ReporteIA({ filtros }) {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);

  useEffect(() => {
    let alive = true;
    setLoading(true);
    setError(false);
    API.get(`/reportes/ia/resumen?${buildQuery(filtros).toString()}`)
      .then((r) => alive && r.data.status === 'success' && setData(r.data.data))
      .catch(() => alive && setError(true))
      .finally(() => alive && setLoading(false));
    return () => { alive = false; };
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [filtros.fechaDesde, filtros.fechaHasta]);

  if (loading) return <Cargando />;
  if (error) return <ErrorMsg />;
  if (!data) return null;

  const res = data.resumen;
  const intents = data.intents || [];
  const errores = data.errores_por_categoria || [];
  const autocorr = data.autocorrecciones || [];

  const donutData = [
    { label: 'Éxitos', value: res.exitos, color: COL.green },
    { label: 'Fallos', value: res.fallos, color: COL.red },
  ];

  return (
    <div>
      <div style={S.kpiGrid}>
        <Kpi label="Llamadas al bot" value={intFmt(res.total)} color={COL.pri} />
        <Kpi label="Tasa de éxito" value={pctFmt(res.tasa_exito * 100)} color={res.tasa_exito >= 0.9 ? COL.green : COL.amber} />
        <Kpi label="Costo total" value={money(res.costo_usd)} sub={`${money(res.costo_bs)} en Bs`} />
        <Kpi label="Latencia promedio" value={`${intFmt(res.tiempo_promedio_ms)}ms`} sub={`p95: ${intFmt(res.tiempo_p95_ms)}ms`} />
        <Kpi label="Tokens" value={intFmt(res.tokens_input + res.tokens_output)} sub={`${intFmt(res.tokens_input)} in · ${intFmt(res.tokens_output)} out`} />
        <Kpi label="Cache hit" value={pctFmt((res.cache_hit / Math.max(res.cache_hit + res.cache_miss, 1)) * 100)} sub={`${intFmt(res.cache_hit)} tokens cacheados`} />
      </div>

      <div style={S.cardGrid}>
        <SectionCard title="Resultado de respuestas" icon={FiCpu} color={COL.pri}>
          <Donut data={donutData} />
        </SectionCard>

        <SectionCard title="Intenciones detectadas" icon={FiCpu} color={COL.pri2}>
          <BarsH items={intents.map((i) => ({ label: i.intent, value: i.count }))} fmt={intFmt} color={COL.pri2} />
        </SectionCard>

        <SectionCard title="Errores por categoría" icon={FiCpu} color={COL.red}>
          <BarsH items={errores.map((e) => ({ label: e.categoria, value: e.count }))} fmt={intFmt} color={COL.red} />
        </SectionCard>

        <SectionCard title="Autocorrecciones" icon={FiCpu} color={COL.purple} hint="Falsos positivos corregidos por el clasificador">
          <BarsH items={autocorr.map((a) => ({ label: a.tipo || 'general', value: a.count }))} fmt={intFmt} color={COL.purple} />
          {autocorr.length === 0 && <div style={{ textAlign: 'center', padding: '16px', color: COL.muted, fontSize: '12px' }}>Sin autocorrecciones registradas</div>}
        </SectionCard>
      </div>
    </div>
  );
}
